import { BRAND } from '@/lib/const';

export const TIME_SLOT = {
  BEFORE_9: 'Before 9:00 (Mon-Sat)',
  BETWEEN_9_AND_12: '9:00 - 12:00 (Mon-Sat)',
  BETWEEN_11_AND_14: '11:00 - 14:00 (Mon-Fri)',
  BETWEEN_17_AND_20: '17:00 - 20:00 (Mon-Fri)',
};

export const ACCOUNT_METADATA = {
  scTermsAccepted: 'user.sc_terms_accepted',
  dob: 'user.dob',
  newsletterConsent: 'user.newsletterConsent',
  boutiqueCommunicationOptin: 'user.btqOptIn',
  personalTitle: 'user.personalTitle',
  phone: 'user.phone',
  phonePrefix: 'user.phonePrefix',
  language: 'user.language',
  country: 'user.country',
  utm_source: 'user.utm_source',
  utm_medium: 'user.utm_medium',
  utm_campaign: 'user.utm_campaign',
  addressSaved: 'saved',
  accountSource: 'Online_Account_source__c',
  first_name_kanji: 'user.first_name_kanji',
  last_name_kanji: 'user.last_name_kanji',
  first_name_romaji: 'user.first_name_romaji',
  last_name_romaji: 'user.last_name_romaji',
  first_name_katakana: 'user.first_name_katakana',
  last_name_katakana: 'user.last_name_katakana',
  houseMansionName: 'address.house_mansion',
  apartmentNumber: 'address.apartment_number',
  vatNumber: 'address.vatNumber',
  abn: 'address.abn',
  isClubMember: 'user.is_club_member',
  isAffiliated: 'user.is_affiliated',
  salesForceId: 'user.salesforce_id',
  brandUsedAtCreation: 'user.brand_used_at_creation',
  brandUsedAtModify: 'user.brand_used_at_modify',
};

export const ACCOUNT_METADATA_VALUE = {
  addressSaved: 'TRUE',
};

export const ORDER_FLOW_METADATA = {
  scTermsAccepted: 'orderFlow.scTermsAccepted',
  scTermsRequired: 'orderFlow.scTermsRequired',
  wasUserAuthenticated: 'orderFlow.wasUserAuthenticated',
  wasRegisterMyWatchChecked: 'orderFlow.wasRegisterMyWatchChecked',
  wasAccountCreated: 'orderFlow.wasAccountCreated',
  createMyAccountWithoutWatch:
    'orderFlow.wasCreateMyAccountWithoutWatchChecked',
  userJoinClub: 'orderFlow.userJoinClub',
  receiveReceipt: 'orderFlow.japanReceipt',
  userAffiliated: 'orderFlow.userAffiliated',
};

export const SALEOR_PRODUCT_VARIANT_METADATA = {
  preOrderConfig: 'product_variant.pre_order_config_v2',
};

export const ONLINE_ACCOUNT_SOURCE = {
  STOREFRONT: 'storefront',
  STOREFRONT_CHECKOUT: 'storefront_checkout',
  BACKOFFICE: 'backoffice',
  SALESAPP: 'salesapp',
};

export const METADATA_BRAND_USED_AT_CREATION = {
  key: ACCOUNT_METADATA.brandUsedAtCreation,
  value: BRAND.toUpperCase(),
};

export const METADATA_BRAND_USED_AT_MODIFY = {
  key: ACCOUNT_METADATA.brandUsedAtModify,
  value: BRAND.toUpperCase(),
};
